import Util from '../util/Util'

export default class Ticker {
  static _offset = 0
  static _tickerOffset = 0
  static _ticker = null

  static _getTickerValues () {
    if (!Ticker._ticker) {
      Ticker._ticker = document.querySelector('.ticker-text')
      Ticker._tickerOffset = Ticker._ticker.offsetWidth * -0.25
    }

    const { transform } = window.getComputedStyle(Ticker._ticker) || {}

    return {
      transform,
    }
  }

  static _interval () {
    const { transform } = Ticker._getTickerValues()

    if (!transform) {
      return
    }

    const xValue = transform.replace(/matrix\((.*)\)/, '$1').split(', ')[5]
    let offset = Number(xValue) + Ticker._offset

    while (offset < Ticker._tickerOffset) {
      offset -= Ticker._tickerOffset
    }

    localStorage.setItem('tickerOffset', offset)
  }

  static init () {
    const priceTicker = document.querySelector('.price-ticker')

    if (priceTicker) {
      priceTicker.addEventListener('click', () => {
        window.location.href = '/unser-strom/stromlieferung#preise'
      })
    }

    const tickerContainer = document.querySelector('.ticker-container')

    if (tickerContainer) {
      Ticker._offset = Util._getNumber('tickerOffset')

      tickerContainer.style.transform = `translate(${Ticker._offset}px, 0)`

      setInterval(Ticker._interval, 100)
    }
  }
}
